export default {"src":"/_next/static/media/EA.08ebe493.svg","height":18,"width":18};